import {Injectable} from '@angular/core';
import {cloudSyncQuery, syncAllMenuQuery, syncAllQuery} from '../../graphql/queries/sync';
import {GraphqlService} from './graphql.service';
import {SyncAllMenu} from '../interfaces/interfaces';
import {SyncAllError, SyncAllMenuError} from '../exceptions/exceptions';
import {SyncAllResponse} from '../../graphql/generated';

@Injectable({
  providedIn: 'root',
})
export class ResourceService {
  constructor(private graphqlService: GraphqlService) {
  }

  async syncAll(serverType: string): Promise<SyncAllResponse> {
    try {
      const response = await this.graphqlService.runQuery(
        syncAllQuery,
        serverType,
      );

      return response.sync_all;
    } catch (error) {
      throw new SyncAllError('Error syncing all data.');
    }
  }

  async syncAllMenu(serverType: string, branchId?: string): Promise<SyncAllMenu> {
    try {
      const response = await this.graphqlService.runQuery(
        syncAllMenuQuery,
        { branchId},
        serverType
      );

      return response.sync_all_menu;
    } catch (error) {
      throw new SyncAllMenuError('Error syncing menu data.');
    }
  }

  async cloudSync(serverType: string): Promise<boolean> {
    try {
      const response = await this.graphqlService.runQuery(
        cloudSyncQuery,
        {},
        serverType,
      );

      return response.cloud_sync.status;
    } catch (error) {
      throw new Error('Error syncing cloud data.');
    }
  }
}
